export const questions = [
  //1
  {
    question: "How many adults suffer from depression globally?",
    options: ["10%", "15%", "5%", "20%"],
    correctAnswer: "5%",
  },
  //2
  {
    question: "Which of the following is the level of depression?",
    options: ["situational", "biological", "psychological", "All of the above"],
    correctAnswer: "All of the above",
  },
  //3
  {
    question: "what is the other name of depression ?",
    options: [
      "dysthymia",
      "persistent depressive disorder",
      "both a and b",
      "none of the above",
    ],
    correctAnswer: "both a and b",
  },
  //4
  {
    question: "Which of the following is the cause of depression ?",
    options: [
      "alcohol and drugs",
      "stressful events",
      "lonliness",
      "all of the above",
    ],
    correctAnswer: "all of the above",
  },
  //5
  {
    question: "Which hormone gets released during depression ?",
    options: [
      "corticotropin releasing hormone",
      "dopamine",
      "testosterone",
      "all of the above",
    ],
    correctAnswer: "corticotropin releasing hormone",
  },
  //6
  {
    question: "Job satisfaction refers to an individual's:",
    options: [
      "Financial compensation",
      "Relationship with coworkers",
      "Overall happiness at work",
      "Work-life balance",
    ],
    correctAnswer: "Overall happiness at work",
  },
  //7
  {
    question: "Which of the following factors can influence job satisfaction?",
    options: [
      "Job security",
      " Employee's gender",
      "Physical environment",
      "Political climate",
    ],
    correctAnswer: "Overall happiness at work",
  },
  //8
  {
    question:
      "The Job Characteristics Theory suggests that job satisfaction is influenced by:",
    options: [
      "Employee's educational background",
      "The level of job autonomy",
      "The size of the organization",
      "The employee's age",
    ],
    correctAnswer: "The level of job autonomy",
  },
  //9
  {
    question:
      "Which of the following is an example of an intrinsic factor that can contribute to job satisfaction?",
    options: [
      "Salary and benefits",
      "Promotion opportunities",
      "Recognition and rewards",
      "Sense of achievement",
    ],
    correctAnswer: "Sense of achievement",
  },
  //10
  {
    question:
      "The Discrepancy Theory of job satisfaction suggests that satisfaction is influenced by:",
    options: [
      "The difference between actual and desired job characteristics",
      "The level of job security",
      "The employee's relationship with supervisors",
      "The organization's mission and values",
    ],
    correctAnswer:
      "The difference between actual and desired job characteristics",
  },
  //11
  {
    question:
      "Effective communication within an organization is essential for:",
    options: [
      "Establishing a clear hierarchy",
      "Ensuring operational efficiency and employee satisfaction",
      "Reducing employee benefits",
      "Increasing competition among employees",
    ],
    correctAnswer: "Ensuring operational efficiency and employee satisfaction",
  },
  //12
  {
    question:
      "Which of the following is NOT a common barrier to effective communication within organizations?",
    options: [
      "Language and cultural differences",
      "Clear and concise messaging",
      "Physical barriers",
      "Emotional barriers",
    ],
    correctAnswer: "Clear and concise messaging",
  },
  //13
  {
    question:
      "Non-verbal communication in an organizational context can include:",
    options: [
      "Financial reports",
      "Body language and facial expressions",
      "Email memos",
      "Policy manuals",
    ],
    correctAnswer: "Body language and facial expressions",
  },
  //14
  {
    question:
      "According to the transactional model of communication, which component is essential for the process to be considered complete?",
    options: [
      "Feedback from the receiver to the sender",
      "A complex message",
      "The use of technical jargon",
      "A large audience",
    ],
    correctAnswer: "Feedback from the receiver to the sender",
  },
  //15
  {
    question:
      "Which of the following strategies is most effective for resolving conflicts in communication within an organization?",
    options: [
      "Avoiding the conflict and hoping it resolves itself",
      "Engaging in active listening and seeking to understand different perspectives",
      "Increasing the distance between conflicting parties",
      "Limiting communication to written forms to avoid emotional exchanges",
    ],
    correctAnswer:
      "Engaging in active listening and seeking to understand different perspectives",
  },
  //16
  {
    question: "Who is the first man to define psychology?",
    options: [
      "Willam James",
      "Wilhelm Wundt",
      "Alfred Adler",
      "Willem MC Dougall",
    ],
    correctAnswer: "Willam James",
  },
  //17
  {
    question: "who gave the term Positive Psychology?",
    options: ["Martian Saligmen", "Abhram Meslow", "Rick Synder", "Ed Diner"],
    correctAnswer: "Martian Saligmen",
  },
  //18
  {
    question: "When a Person changes his cultural identity he/she is Known as?",
    options: ["Foreigner", "Stranger", "Migrated", "Outsider"],
    correctAnswer: "Migrated",
  },
  //19
  {
    question: "What is Psychology?",
    options: [
      "Biological science",
      "Physical science",
      "Social science",
      "Natural science",
    ],
    correctAnswer: "Natural science",
  },
  //20
  {
    question:
      "What is the process by which we organize and interpret sensory information, enabling us to recognize meaningful objects and events?",
    options: ["Perception", "Sensation", "Cognition", "Memory"],
    correctAnswer: "Memory",
  },
  //21
  {
    question:
      "What is the scientific study of behavior and mental processes called?",
    options: ["Sociology", "Anthropology", "Psychology", "Biology"],
    correctAnswer: "Psychology",
  },
  //22
  {
    question:
      "What is the term for the tendency to favor information that confirms our existing beliefs or values?",
    options: [
      "Confirmation bias",
      "Cognitive dissonance",
      "Observer bias",
      "Self-serving bias",
    ],
    correctAnswer: "Confirmation bias",
  },
  //23
  {
    question: "Which part of the brain is responsible for processing emotions?",
    options: ["Cerebellum", "Amygdala", "Hippocampus", "Frontal lobe"],
    correctAnswer: "Amygdala",
  },
  //24
  {
    question:
      "Which branch of psychology focuses on how people think, learn, and remember information?",
    options: [
      "Cognitive psychology",
      "Developmental psychology",
      "Social psychology",
      "Behavioral psychology",
    ],
    correctAnswer: "Cognitive psychology",
  },
  //25
  {
    question: 'Which planet is known as the "Red Planet"?',
    options: ["Earth", "Jupiter", "Mars", "Venus"],
    correctAnswer: "Mars",
  },
  //26
  {
    question: "What is a common positive symptom of schizophrenia?",
    options: [
      "Flat effect",
      "Social withdrawal",
      "Auditory hallucinations",
      "Lack of motivation",
    ],
    correctAnswer: "Auditory hallucinations",
  },
  //27
  {
    question:
      "Which neurotransmitter is most commonly associated with the pathophysiology of schizophrenia?",
    options: ["Serotonin", "Dopamine", "GABA", "Acetylcholine"],
    correctAnswer: "Dopamine",
  },
  //28
  {
    question: "What is a negative symptom of schizophrenia?",
    options: ["Delusions", "Hallucinations", "Alogia", "Disorganized speech"],
    correctAnswer: "Alogia",
  },
  //29
  {
    question: "Which of the following is a first-generation antipsychotic?",
    options: ["Risperidone", "Clozapine", "Haloperidol", "Olanzapine"],
    correctAnswer: "Haloperidol",
  },
  //30
  {
    question:
      "Cognitive Behavioral Therapy (CBT) for schizophrenia is primarily used to:",
    options: [
      "Increase white blood cell count",
      "Address positive symptoms such as hallucinations and delusions",
      "Replace antipsychotic medication",
      "Improve motor coordination",
    ],
    correctAnswer:
      "Address positive symptoms such as hallucinations and delusions",
  },
  //31
  {
    question:
      "Which phase of schizophrenia is characterized by mild symptoms that precede the first full-blown episode?",
    options: [
      "Prodromal phase",
      "Active phase",
      "Residual phase",
      "Recovery phase",
    ],
    correctAnswer: "Prodromal phase",
  },
  //32
  {
    question:
      "What is considered a risk factor for the development of schizophrenia?",
    options: [
      "Vitamin D deficiency",
      "High socioeconomic status",
      "Advanced paternal age",
      "Urban living in developed countries",
    ],
    correctAnswer: "Advanced paternal age",
  },
  //33
  {
    question:
      "Which of the following treatments is known to specifically target treatment-resistant schizophrenia?",
    options: [
      "Lithium",
      "Clozapine",
      "Fluoxetine",
      "Cognitive remediation therapy",
    ],
    correctAnswer: "Clozapine",
  },
  //34
  {
    question: "What type of hallucinations are most common in schizophrenia?",
    options: ["Visual", "Auditory", "Olfactory", "Tactile"],
    correctAnswer: "Auditory",
  },
  //35
  {
    question: "Schizophrenia is best described as which type of disorder?",
    options: [
      "Mood disorder",
      "Personality disorder",
      "Neurodevelopmental disorder",
      "Psychotic disorder",
    ],
    correctAnswer: "Psychotic disorder",
  },
  //36
  {
    question:
      "Which of the following is NOT a component of the classical conditioning process?",
    options: [
      "Unconditioned stimulus (UCS)",
      "Conditioned stimulus (CS)",
      "Neutral stimulus (NS)",
      "Response",
    ],
    correctAnswer: "Response",
  },
  //37
  {
    question: "Who is known as the founder of psychoanalysis?",
    options: ["Carl Rogers", "Sigmund Freud", "B.F. Skinner", "Ivan Pavlov"],
    correctAnswer: "",
  },
  //38
  {
    question: "What is the primary focus of social psychology?",
    options: [
      "Studying individual behavior",
      "Studying group behavior and social influences",
      "Studying the biological bases of behavior",
      "Studying mental disorders",
    ],
    correctAnswer: "Studying group behavior and social influences",
  },
  //39
  {
    question:
      "The study of mental processes such as perception, memory, and problem-solving is known as",
    options: [
      "Behaviorism",
      "Psychometrics",
      "Cognitive psychology",
      "Developmental psychology",
    ],
    correctAnswer: "Cognitive psychology",
  },

  //40
  {
    question:
      "Which of the following is considered a central nervous system depressant?",
    options: ["Cocaine", "Alcohol", "Caffeine", "Nicotine"],
    correctAnswer: "Alcohol",
  },

  //41
  {
    question:
      "Which of the following substances is most associated with the risk of developing a dependency?",
    options: ["Sugar", "Alcohol", "Caffeine", "Aspirin"],
    correctAnswer: "Alcohol",
  },

  //42
  {
    question: "Which of the following is a common symptom of depression?",
    options: [
      "Increased energy levels",
      "Persistent feelings of sadness or emptiness",
      "Heightened sense of self-esteem",
      "Improved concentration and focus",
    ],
    correctAnswer: "Persistent feelings of sadness or emptiness",
  },

  //43
  {
    question: "Which of the following is a common symptom of depression?",
    options: [
      "Increased energy levels",
      "Persistent feelings of sadness or emptiness",
      "Heightened sense of self-esteem",
      "Improved concentration and focus",
    ],
    correctAnswer: "Persistent feelings of sadness or emptiness",
  },

  //44
  {
    question: "Which of the following is a common positive emotion?",
    options: ["Sadness", "Anger", "Joy", "Anxiety"],
    correctAnswer: "Joy",
  },

  //45
  {
    question: "Gratitude is an example of a:",
    options: [
      "Negative emotion",
      "Neutral emotion",
      "Positive emotion",
      "Cognitive distortion",
    ],
    correctAnswer: "Positive emotion",
  },

  //46
  {
    question: "What does PTSD stand for?",
    options: [
      "Post-Traumatic Sleep Disorder",
      "Post-Traumatic Stress Disorder",
      "Persistent Traumatic Shock Distress",
      "Panic Triggered Stress Disorder",
    ],
    correctAnswer: "Post-Traumatic Stress Disorder",
  },

  //47
  {
    question: "Post-Traumatic Stress Disorder",
    options: ["Yes", "No", "prefer not to say", "none of the above"],
    correctAnswer: "No",
  },

  //48
  {
    question: "Which of the following is a symptom of schizophrenia?",
    options: ["Hallucinations", "Delusions", "Apathy", "All of the above"],
    correctAnswer: "All of the above",
  },

  //49
  {
    question: "What is a sleep disorder?",
    options: [
      "A type of dream",
      "A new type of mattress",
      "A condition that disrupts normal sleep patterns",
      "A form of meditation",
    ],
    correctAnswer: "A condition that disrupts normal sleep patterns",
  },

  //50
  {
    question: "What is a migraine?",
    options: [
      "A chest pain",
      "A leg pain",
      "A headache disorder with throbbing pain",
      "A stomach pain",
    ],
    correctAnswer: "A headache disorder with throbbing pain",
  },
];
